var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTooltipInformation = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7,
  fill: "#fff",
  stroke: "#5A687B"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5A687B",
  d: "M7 7h2v5H7zM7 4h2v2H7z"
})));
export { SvgTooltipInformation as ReactComponent };
export default __webpack_public_path__ + "assets/media/tooltip-information.a75f5b37d07ed10c238b405316bd33a7.svg";